import * as React from 'react'
import { theme } from '../theme'

interface Props {
    onClick: () => void
    disabled: boolean
    isLoading: boolean
}

export const GenerateButton = ({
    onClick,
    disabled,
    isLoading
}: Props) => {
    const [isHovered, setIsHovered] = React.useState(false)

    return (
        <button
            onClick={onClick}
            disabled={disabled || isLoading}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                padding: '10px 20px',
                borderRadius: theme.borderRadius.sm,
                border: 'none',
                backgroundColor: isHovered ? 'rgba(47, 123, 118, 0.9)' : '#2F7B76',
                color: 'white',
                cursor: disabled || isLoading ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: 500,
                transition: 'background-color 0.2s ease',
                opacity: disabled || isLoading ? 0.6 : 1,
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
            }}
        >
            {isLoading ? (
                <>
                    <span className="loading-spinner" />
                    Generating...
                </>
            ) : (
                'Generate with AI'
            )}
        </button>
    )
}
